<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 10:22:56
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\AbnormalPunchReason\newAbnormalPunchReason.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-09-06 15:03:14
-->
<template>
  <ContentLayout
    widthClass="max-1000"
    :title="$t('label_essweb_abnormalPunchReason_form_newTitle')"
    :initData="ReasonData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'punch_invalid_reason_name',
      'sequence',
      'punch_invalid_reason_description',
      'punch_invalid_reason_code',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="ReasonData.punch_invalid_reason_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  ReasonData.punch_invalid_reason_name = valueArr;
                }
              "
              :label="$t('label_essweb_abnormalPunchReason_form_nameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              type="number"
              maxlength="255"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 255])
              "
              :label="
                $t('label_essweb_abnormalPunchReason_form_sequennceLabel;')
              "
              isNotRequire
              v-model="ReasonData.sequence"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="$t('label_essweb_abnormalPunchReason_form_codeLabel')"
              maxlength="50"
              v-model="ReasonData.punch_invalid_reason_code"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="ReasonData.punch_invalid_reason_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  ReasonData.punch_invalid_reason_description = valueArr;
                }
              "
              :label="
                $t('label_essweb_abnormalPunchReason_form_descriptionLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_abnormalPunchReason_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              filled
              dense
              single-line
              v-model="ReasonData.remarks"
              counter="500"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions newBtn @new="toAdd" @cancel="$toBack(isChanged)" />
    </template>
    <!-- actions -->
  </ContentLayout>
</template>
<script>
export default {
  name: "newPunchVerifyFailedReason",
  data() {
    return {
      isChanged: false,
      ReasonData: {
        punch_invalid_reason_name: "",
        sequence: 1,
        punch_invalid_reason_description: "",
        punch_invalid_reason_code: "",
        remarks: "",
      },
    };
  },
  mounted() {
    // this.ReasonData.punch_invalid_reason_name = this.$getCommonLangKey();
    // this.ReasonData.punch_invalid_reason_description = this.$getCommonLangKey();
  },
  methods: {
    toAdd: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_punch_invalid_reason",
        url: "/punch-invalid-reason/add-punch-invalid-reason-table/",
        data: {
          punch_invalid_reason_code: this.ReasonData.punch_invalid_reason_code,
          sequence: this.ReasonData.sequence,
          punch_invalid_reason_name: this.$transCommonLangKey(
            this.ReasonData.punch_invalid_reason_name
          ),
          punch_invalid_reason_description: this.$transCommonLangKey(
            this.ReasonData.punch_invalid_reason_description
          ),
          remarks: this.ReasonData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
  },
};
</script>
